import { useEffect, useMemo, useState } from 'react';

const DEFAULT_PHASES = [
  'Lumi spinning up…',
  'Warming up the color engine…',
  'Polishing axes & grids…',
  'Setting up the editor…',
  'Almost there…'
];

export default function BootScreen({ message = 'Lumi spinning up…' }: { message?: string }) {
  const phases = useMemo(() => DEFAULT_PHASES, []);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setIdx((i) => (i + 1) % phases.length), 1400);
    return () => clearInterval(timer);
  }, [phases.length]);
  const text = message || phases[idx];
  return (
    <div className="min-h-screen w-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 bg-[#FFD700] rounded-lg flex items-center justify-center mx-auto mb-4">
          <div className="w-6 h-6 border-4 border-[#2D3748] border-t-transparent rounded-full animate-spin" />
        </div>
        <p className="text-muted-foreground">{text}</p>
      </div>
    </div>
  );
}


